<template>
    <div>
        <b-overlay
            :show="dataOverlay"
            spinner-variant="success"
            no-wrap
        ></b-overlay>
        <div class="d-flex justify-content-start align-items-center mb-4">
            <div>
                <h5 class="m-0">Детали водителя <span class="text-secondary">{{items.name}}</span> (#{{items.id}})</h5>
            </div>
            <div class="ml-3">
                <b-badge variant="success" class="always-small-badge" v-if="items.passport_checked == 444"><i class='bx bx-check'></i> Паспорт в порядке!</b-badge>
                <b-badge variant="secondary" class="always-small-badge" v-if="items.passport_checked == 443">Паспорт на проверке</b-badge>
                <b-badge variant="danger" class="always-small-badge" v-if="items.passport_checked == 445">Паспорт не прошел проверку!</b-badge>
            </div>
            <div class="ml-3">
                <b-badge variant="success" class="always-small-badge" v-if="items.driver_card_checked == 444"><i class='bx bx-check'></i> Права в порядке!</b-badge>
                <b-badge variant="secondary" class="always-small-badge" v-if="items.driver_card_checked == 443">Права на проверке</b-badge>
                <b-badge variant="danger" class="always-small-badge" v-if="items.driver_card_checked == 445">Права не прошли проверку!</b-badge>
            </div>
        </div>
        <table class="table table-hover table-borderless table-fixed">
            <tbody>
                <tr>
                    <td class="table-title-details">ФИО водителя</td>
                    <td>{{items.name || "Не указано"}}</td>
                </tr>
                <tr>
                    <td class="table-title-details">Телефоны водителя</td>
                    <td>
                        {{items.phone || "Не указан"}}
                        <template v-if="items.phone_additional">
                            <br>{{items.phone_additional}}
                        </template>
                    </td>
                </tr>
                <tr>
                    <td class="table-title-details">Водитель закреплен в компаниях</td>
                    <td>
                        <template v-if="items.companies && items.companies.length > 0">
                            <ul class="disc-lists">
                                <template v-for="company in items.companies">
                                    <li>{{ company.name }} ({{ company.inn }})</li>
                                </template>
                            </ul>
                        </template>
                        <template v-else>
                            Пока не прикреплен ни к одной компании
                        </template>
                    </td>
                </tr>
                <tr>
                    <td class="table-title-details">Водительское удостоверение</td>
                    <td>
                        <b>Серия и номер:</b> {{ items.driver_card_number || "Не указан" }}<br>
                        <b>Действительны ДО:</b> {{ (items.driver_card_ends_at || "Не указан") | formattedDate }}<br>
                    </td>
                </tr>
                <tr>
                    <td class="table-title-details">Сканы водительского удостоверения</td>
                    <td>
                        <div class="d-flex flex-row bd-highlight mb-3">
                            <div class="p-2 text-center">
                                <template v-if="items.driver_card_file_face">
                                    <a :href="hfs+items.driver_card_file_face.path" target="_blank"><img :id="'doc-logo-'+items.id" :src="'/img/icon-document.svg'" style="width: 60px;"></a>
                                    <div class="text-secondary font-weight-bold mt-2">Лицевая сторона</div>
                                </template>
                                <template v-else>
                                    <img :id="'doc-logo-'+items.id" :src="'/img/icon-document.svg'" style="width: 60px; opacity: 0.6;">
                                    <div class="text-secondary mt-2">Лицевая сторона<br><span class="text-danger">не приложена</span></div>
                                </template>
                            </div>
                            <div class="p-2 text-center">
                                <template v-if="items.driver_card_file_back">
                                    <a :href="hfs+items.driver_card_file_back.path" target="_blank"><img :id="'doc-logo-'+items.id" :src="'/img/icon-document.svg'" style="width: 60px;"></a>
                                    <div class="text-secondary font-weight-bold mt-2">Оборотная сторона</div>
                                </template>
                                <template v-else>
                                    <img :id="'doc-logo-'+items.id" :src="'/img/icon-document.svg'" style="width: 60px; opacity: 0.6;">
                                    <div class="text-secondary mt-2">Оборотная сторона<br><span class="text-danger">не приложена</span></div>
                                </template>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="table-title-details">Паспорт водителя</td>
                    <td>
                        <b>Серия и номер:</b> {{ items.passport_number || "Не указан" }}<br>
                        <b>Кем выдан:</b> {{ items.passport_issued_by || "Не указан" }}<br>
                        <b>Когда выдан:</b> {{ (items.passport_issued_date || "Не указан") | formattedDate }}<br>
                        <b>Дата рождения:</b> {{ (items.passport_birth_date || "Не указан") | formattedDate }}<br>
                        <b>Город рождения:</b> {{ items.passport_birth_town || "Не указан" }}<br>
                        <b>Адрес регистрации:</b> {{ items.passport_address || "Не указан" }}<br>
                    </td>
                </tr>
                <tr>
                    <td class="table-title-details">Сканы паспорта</td>
                    <td>
                        <div class="d-flex flex-row bd-highlight mb-3">
                            <div class="p-2 text-center">
                                <template v-if="items.passport_file_photo">
                                    <a :href="hfs+items.passport_file_photo.path" target="_blank"><img :id="'doc-logo-'+items.id" :src="'/img/icon-document.svg'" style="width: 60px;"></a>
                                    <div class="text-secondary font-weight-bold mt-2">Разворот с фото</div>
                                </template>
                                <template v-else>
                                    <img :id="'doc-logo-'+items.id" :src="'/img/icon-document.svg'" style="width: 60px; opacity: 0.6;">
                                    <div class="text-secondary mt-2">Разворот с фото<br><span class="text-danger">не приложен</span></div>
                                </template>
                            </div>
                            <div class="p-2 text-center">
                                <template v-if="items.passport_file_address">
                                    <a :href="hfs+items.passport_file_address.path" target="_blank"><img :id="'doc-logo-'+items.id" :src="'/img/icon-document.svg'" style="width: 60px;"></a>
                                    <div class="text-secondary font-weight-bold mt-2">Разворот с адресом</div>
                                </template>
                                <template v-else>
                                    <img :id="'doc-logo-'+items.id" :src="'/img/icon-document.svg'" style="width: 60px; opacity: 0.6;">
                                    <div class="text-secondary mt-2">Разворот с адресом<br><span class="text-danger">не приложен</span></div>
                                </template>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import {
    API_DRIVERS,
    HOST_FOR_STORAGE
} from '../../constants'

export default {
    props: {
        itemId: { type: Number, required: false },
    },
    data() {
        return {
            api: API_DRIVERS,
            items: '',
            dataOverlay: true,
            hfs: HOST_FOR_STORAGE
        }
    },
    mounted() {
        this.getDriver(this.itemId)
    },
    methods: {
        getDriver(id){
            api.call('get', `${this.api}/${id}`).then(({data}) => {
                this.items = data
                this.dataOverlay = false
            })
        },
    }
}
</script>
